import { useEffect, useState } from 'react';
import { useLayoutContext } from '../Layout';

export function useReadElementHeight(
    elementRef: React.RefObject<HTMLElement>,
    cssVarName?: string,
) {
    const [height, setHeight] = useState<number | undefined>();
    const { setLayoutCssProperty } = useLayoutContext();

    useEffect(() => {
        if (!elementRef.current) return;

        const observer = new ResizeObserver(([entry]) => {
            const newHeight = entry.contentRect.height;
            if (newHeight) {
                setHeight(newHeight);

                if (cssVarName) {
                    setLayoutCssProperty({
                        name: cssVarName,
                        value: `${newHeight}px`,
                    });
                }
            }
        });

        observer.observe(elementRef.current);

        return () => {
            observer.disconnect();
            if (cssVarName) {
                setLayoutCssProperty({ name: cssVarName, value: '' });
            }
        };
    }, [elementRef, cssVarName, setLayoutCssProperty]);

    return height;
}
